import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../pages/layout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/2608-midautu",
    name: "login",
    component: () => import("../pages/login")
  },
  {
    path: "/survey",
    name: "survey",
    component: Layout,
    children: [
      {
        path: "/index",
        name: "index",
        component: () => import("../pages/index")
      },
      {
        path: "/score",
        name: "score",
        component: () => import("../pages/score")
      }, {
        path: "/staff",
        name: "staff",
        component: () => import("../pages/staff")
      },
      {
        path: "/info",
        name: "info",
        component: () => import("../pages/info")
      }
    ]
  },
  {
    path: "*",
    name: "error",
    component: () => import("../pages/error")
  }
  // {
  //     path: '/register',
  //     name: 'register',
  //     component:() => import('../pages/register')
  // },
  // {
  //     path: '/address',
  //     name: 'address',
  //     component:() => import('../pages/address')
  // },
  // {
  //     path: '/result',
  //     name: 'result',
  //     component:() => import('../pages/result')
  // },

  // {
  //     path: '/register',
  //     name: 'register',
  //     component: RegisterLayout,
  //     children: [
  //         {
  //             path: 'place',
  //             name: 'register.place',
  //             component: () => import('../pages/register/place')
  //         },
  //     ]
  // }

];

const router = new VueRouter({
  routes
});

export default router;
